import { atom } from "jotai";

// スライダー(react-slick)の現在のインデックスを保持する
export const currentSliderIndexAtom = atom<number>(0);
currentSliderIndexAtom.debugLabel = "currentSliderIndexAtom";
